<template>
  <div class="layout-content-wrapper">
    <router-view v-show="activeLoader === false" />
    <loader v-show="activeLoader === true"></loader>
  </div>
</template>

<script>
import Loader from "./components/Loader.vue";
export default {
  components: { Loader },
  data() {
    return {};
  },
  computed: {
    activeLoader() {
      return this.$store.getters["loader/activeLoader"];
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss">
@import "App.scss";
</style>
